import api from '@/lib/axios';

export interface ApiResponse<T> {
  data: T;
  message?: string;
}

export interface PaginatedData<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export abstract class BaseService<T, CreateDTO, UpdateDTO> {
  constructor(protected baseUrl: string) {}

  async getAll(params?: Record<string, any>): Promise<ApiResponse<T[]>> {
    const response = await api.get<T[] | ApiResponse<T[]>>(this.baseUrl, { params });
    // Se o backend retorna array diretamente, envolve em ApiResponse
    // Se já vem no formato ApiResponse, retorna como está
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    return response.data;
  }

  async getById(id: string): Promise<ApiResponse<T>> {
    const response = await api.get<T | ApiResponse<T>>(`${this.baseUrl}/${id}`);
    if (response.data && typeof response.data === 'object' && 'data' in (response.data as any)) {
      return response.data as ApiResponse<T>;
    }
    return { data: response.data as T };
  }

  async create(data: CreateDTO): Promise<ApiResponse<T>> {
    const response = await api.post<T | ApiResponse<T>>(this.baseUrl, data);
    if (response.data && typeof response.data === 'object' && 'data' in (response.data as any)) {
      return response.data as ApiResponse<T>;
    }
    return { data: response.data as T };
  }

  async update(id: string, data: UpdateDTO): Promise<ApiResponse<T>> {
    const response = await api.put<T | ApiResponse<T>>(`${this.baseUrl}/${id}`, data);
    if (response.data && typeof response.data === 'object' && 'data' in (response.data as any)) {
      return response.data as ApiResponse<T>;
    }
    return { data: response.data as T };
  }

  async delete(id: string): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
    return response.data;
  }
}
